import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Switch,
    FormControlLabel,
    Grid,
    CircularProgress,
    Menu,
    Tooltip
} from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon, MoreVert as MoreVertIcon } from '@mui/icons-material';
import { useNavigate, Link } from 'react-router-dom';
import moment from 'moment';
import {
    getAllPromoCoupons,
    deletePromoCoupon,
    createPromoCoupon,
    updatePromoCoupon,
    formatPromoCouponData
} from '../../../services/timesPoint/promoCoupon';
import PromoCouponBannerForm from './PromoCouponBannerForm';
import Swal from 'sweetalert2';
import CustomTable from '../../../components/CustomTable';
import { filterList } from '../../../libs/utils';
import SearchIcon from '@mui/icons-material/Search';

const PromoCouponList = () => {
    const navigate = useNavigate();
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [formData, setFormData] = useState({
        type: 'web',
        state: 'ALL_USERS',
        viewport: 'abound-earn-banner',
        height: 230,
        width: 680,
        status: true,
        banners: [{
            linkUrl: '',
            sequenceNo: 1,
            title: '',
            imageUrl: '',
            startDate: Date.now(),
            endDate: Date.now() + 30 * 24 * 60 * 60 * 1000,
            pageType: ['all']
        }]
    });
    const [rows, setRows] = useState();
    const [searchKey, setSearchKey] = useState("");

    const columns = [
        {
            id: "type",
            label: "Type",
            minWidth: 100,
            sortable: true,
            align: "left",
            enableSort: true,
        },
        {
            id: "state",
            label: "State",
            minWidth: 100,
            sortable: true,
            align: "left",
            enableSort: true,
        },
        {
            id: "viewport",
            label: "Viewport",
            minWidth: 100,
            sortable: true,
            align: "left",
            enableSort: true,
        },
        {
            id: "status",
            label: "Status",
            minWidth: 100,
            sortable: true,
            align: "left",
            enableSort: true,
        },
        {
            id: "Action",
            label: "Action",
            minWidth: 100,
            align: "left",
        },
    ];

    const searchData = (e) => {
        setSearchKey(e.target.value);
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const dataGenerator = ({
        type,
        state,
        viewport,
        status,
        _id,
    }) => {
        return {
            type,
            state,
            viewport,
            status: status ? "Active" : "Inactive",
            Action: (
                <Link
                    to={`/app/banner/${_id && _id.toString ? _id.toString() : _id}`}
                    style={{ textDecoration: "none" }}
                >
                    <Button variant="contained" size="small" color="warning">
                        Edit
                    </Button>
                </Link>
            ),
        };
    };

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            setLoading(true);
            const response = await getAllPromoCoupons();
            if (response.data && response.data.status == 'SUCCESS') {
                setCoupons(response.data.data);
                response.data.data.forEach((promoCoupon, idx) => {
                    console.log('PromoCoupon _id at index', idx, ':', promoCoupon._id);
                });
                setRows(response.data.data.map((promoCoupon) => dataGenerator({
                    ...promoCoupon,
                    _id: promoCoupon._id && promoCoupon._id.toString ? promoCoupon._id.toString() : promoCoupon._id
                })));
            }
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.message,
                icon: 'error'
            });
        } finally {
            setLoading(false);
        }
    };

   

    

    const handleSubmit = async () => {
        try {
            setSubmitting(true);
            const response = selectedCoupon
                ? await updatePromoCoupon(selectedCoupon._id, formData)
                : await createPromoCoupon(formData);

            if (response.status === 'SUCCESS') {
                Swal.fire({
                    title: 'Success',
                    text: selectedCoupon ? 'Banners updated successfully' : 'Banners created successfully',
                    icon: 'success'
                });
                setOpenDialog(false);
                fetchCoupons();
            }
        } catch (error) {
            Swal.fire({
                title: 'Error',
                text: error.message,
                icon: 'error'
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleBannerAdd = () => {
        setFormData(prev => ({
            ...prev,
            banners: [...prev.banners, {
                linkUrl: '',
                sequenceNo: prev.banners.length + 1,
                title: '',
                imageUrl: '',
                startDate: Date.now(),
                endDate: Date.now() + 30 * 24 * 60 * 60 * 1000,
                pageType: ['all']
            }]
        }));
    };

    const handleBannerRemove = (index) => {
        setFormData(prev => ({
            ...prev,
            banners: prev.banners.filter((_, i) => i !== index)
        }));
    };

    const handleBannerChange = (updatedBanners) => {
        setFormData(prev => ({
            ...prev,
            banners: updatedBanners
        }));
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                <Typography variant="h4">Banners</Typography>
                <div style={{ display: "flex", alignItems: "end" }}>
                    <TextField
                        id="standard-basic"
                        label="Search"
                        variant="standard"
                        sx={{ mr: 1 }}
                        onKeyUp={(e) => searchData(e)}
                        InputProps={{
                            endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
                        }}
                    />

                    <Tooltip title="Choose Option">
                        <IconButton
                            onClick={handleClick}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={open ? "account-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                        >
                            <MoreVertIcon sx={{ width: 32, height: 32 }} />
                        </IconButton>
                    </Tooltip>
                    <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                            elevation: 0,
                            sx: {
                                overflow: "visible",
                                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                mt: 1.5,
                                "& .MuiAvatar-root": {
                                    width: 32,
                                    height: 32,
                                    ml: -0.5,
                                    mr: 1,
                                },
                                "&:before": {
                                    content: '""',
                                    display: "block",
                                    position: "absolute",
                                    top: 0,
                                    right: 14,
                                    width: 10,
                                    height: 10,
                                    bgcolor: "background.paper",
                                    transform: "translateY(-50%) rotate(45deg)",
                                    zIndex: 0,
                                },
                            },
                        }}
                        transformOrigin={{ horizontal: "right", vertical: "top" }}
                        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                        <MenuItem
                            sx={{
                                "&:hover": {
                                    background: "#f9da8792",
                                    color: "#000",
                                },
                            }}
                        >
                            <Link to="/app/banner/0" style={{ color: "#040721" }}>
                                Add New Banners
                            </Link>
                        </MenuItem>
                    </Menu>
                </div>
            </Box>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <CustomTable
                    data={filterList(rows, searchKey) || []}
                    columns={columns}
                />
            )}

            <Dialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {selectedCoupon ? 'Edit Banners' : 'Create Banners'}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel>Type</InputLabel>
                                <Select
                                    value={formData.type}
                                    onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                                >
                                    <MenuItem value="web">Web</MenuItem>
                                    <MenuItem value="mobile">Mobile</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <InputLabel>State</InputLabel>
                                <Select
                                    value={formData.state}
                                    onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                                >
                                    <MenuItem value="ALL_USERS">All Users</MenuItem>
                                    <MenuItem value="NEW_USERS">New Users</MenuItem>
                                    <MenuItem value="EXISTING_USERS">Existing Users</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Viewport"
                                value={formData.viewport}
                                onChange={(e) => setFormData({ ...formData, viewport: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Height"
                                value={formData.height}
                                onChange={(e) => setFormData({ ...formData, height: parseInt(e.target.value) })}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                fullWidth
                                type="number"
                                label="Width"
                                value={formData.width}
                                onChange={(e) => setFormData({ ...formData, width: parseInt(e.target.value) })}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formData.status}
                                        onChange={(e) => setFormData({ ...formData, status: e.target.checked })}
                                    />
                                }
                                label="Active"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <PromoCouponBannerForm
                                banners={formData.banners}
                                onChange={handleBannerChange}
                                onAdd={handleBannerAdd}
                                onRemove={handleBannerRemove}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={submitting}
                    >
                        {submitting ? (
                            <CircularProgress size={24} />
                        ) : (
                            selectedCoupon ? 'Update' : 'Create'
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default PromoCouponList; 